export const tr = {
    languages: {
        cs: 'Çekçe',
        de: 'Almanca',
        en: 'İngilizce',
        es: 'İspanyolca',
        fr: 'Fransızca',
        hr: 'Hırvatça',
        hu: 'Macarca',
        it: 'İtalyanca',
        nl: 'Flemenkçe',
        pl: 'Lehçe',
        ru: 'Rusça',
        sk: 'Slovakça',
        tr: 'Türkçe',
        uk: 'Ukraynaca',
        undefined: 'Altyazı yok',
    },
    player: {
        content: {
            notFound: { title: 'Medya öğesi yüklenirken hata oluştu 😞' },
        },
        controls: {
            backwards: { title: '10s geri' },
            buffering: { title: 'Yükleniyor...' },
            captions: { title: 'Altyazılar' },
            forwards: { title: '10s ileri' },
            fullscreen: { title: 'Tam ekran' },
            pause: { title: 'Duraklat' },
            play: { title: 'Oynat' },
            playlist: { title: 'Oynatma listesi' },
            volume: { title: 'Ses' },
        },
    },
};
